import React, { useState } from 'react';
import { Button } from '@scuf/common';

import { consumeAPIs, IAPIPackage } from '../../commonUtils/APIContext';
import toasts from '../../commonUtils/toasts';
import { v4 as uuid4 } from 'uuid';
import { IOrganisation, IOrganisationUsers } from '../onboardingModels';
import i18next from '../../../i18next';

interface IResendUserActivationProps extends IAPIPackage {
  email: string;
  organisation: IOrganisation;
  onResend: Function;
}

export const ResendUserActivation = (props: IResendUserActivationProps) => {
  const [loader, setLoader] = useState<boolean>(false);
  const resendActivation = () => {
    setLoader(true);
    props
      .authFetch(
        `${
          props.baseURL
        }/api/v1/registered-users/orgs/${props.organisation.id}/generate-otp-commands/${uuid4()}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: props.email
          })
        }
      )
      .then(response => response.json())
      .then(response => {
        if (response.output.status === 'SUCCESS') {
          toasts.success(i18next.t('emailSentSuccess'));
          const user: IOrganisationUsers = response.output.response;
          props.onResend(user);
        } else {
          throw new Error(i18next.t('requestFailed'));
        }
      })
      .catch(e => {
        console.log(i18next.t('activationEmailError'));
        toasts.error(i18next.t('activationEmailError1'));
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <Button
      type="link"
      content={i18next.t('resend')}
      className="resend-btn"
      loading={loader}
      onClick={() => resendActivation()}
    />
  );
};

export default consumeAPIs(ResendUserActivation);
